import { useMemo, useState } from 'react'
import EstoqueHttp from '../../../../../../services/api/https/estoque/Estoque.http'
import { errorHandler } from '../../../../../../services/util/error.service'

export const MENU_ITEMS = ['1. Editar', '2. Produtos']

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_ESTOQUES: 'Carregando estoques',
  PRODUCTS: 'Carregando produtos para expedir',
  PRODUCTS_FROM_STOCK: 'Carregando produtos do estoque',
  PALLETS_FROM_STOCK: 'Carregando pallets do estoque',
  MOVING: 'Concluindo operação',
  ASSOC_FIFO: 'Associando produtos automaticamente',
}

const INITIAL_STATE = {
  originalprodutosPalletsEstoque: [],
  originalProdutosEstoque: [],
  originalProdutosExpedir: [],
  produtosParaExpedir: [],
  produtosEstoque: [],
  produtosPalletsEstoque: [],
  selectedProduto: null,
  selectedEstoque: null,
  selectedProdutosEstoque: [],
  selectedProdutosPallets: [],
  selectedEstoquesAutomatico: [],
  estoquesFilteredByAutomatico: [],
  searchProdutosExpedicao: '',
  searchprodutosPalletsEstoque: '',
  estoques: [],
  globalFilter: '',
  searchPallet: '',
  activeIndex: 0,
  activeMainTab: 0,
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  successMessage: null,
}

export default function useMovimentacaoEstoque() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    // validade chega como "dd/mm/yyyy"; gera um número yyyymmdd para ordenar como data
    const addValidadeSort = produto => ({
      ...produto,
      validade_sort: produto.validade
        ? Number(String(produto.validade).split('/').reverse().join(''))
        : null,
    })

    return {
      setActiveMainTab(value) {
        setState(prev => ({ ...prev, activeMainTab: value }))
      },
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
          successMessage: null,
          pathToRedirect: null,
        }))
      },

      getEstoquesFromTp(selectedTp) {
        EstoqueHttp.getEstoques(selectedTp)
          .then(res =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              estoques: [
                { id: 0, name: 'Todos' },
                ...res.map(estoque => ({ id: estoque.id, name: estoque.name })),
              ],
              selectedEstoque: { id: 0, name: 'Todos' },
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      getProdutosExpedicao(selectedTp, expedicaoId) {
        EstoqueHttp.getProdutosFromExpedicaoId(selectedTp, expedicaoId)
          .then(res =>
            setState(prevState => ({
              ...prevState,
              produtosPalletsEstoque: [],
              produtosEstoque: [],
              selectedProduto: null,
              produtosParaExpedir: res.map(p => addValidadeSort({ ...p, alocated: false })),
              originalProdutosExpedir: res.map(p =>
                addValidadeSort({
                  ...p,
                  alocated: false,
                  qte_alocar: p.qte_total,
                }),
              ),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err => setState(prevState => ({ ...prevState, errorMessage: errorHandler(err) })))
      },

      async getProdutosEstoque(selectedTp, expedicaoId, productId) {
        EstoqueHttp.getProdutosFromEstoqueParaExpedir(selectedTp, expedicaoId, productId)
          .then(res =>
            setState(prevState => ({
              ...prevState,
              produtosEstoque: this.mapProdutosFromEstoque(res),
              originalProdutosEstoque: this.mapProdutosFromEstoque(res),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      mapProdutosFromEstoque(produtos) {
        return produtos.map(p => {
          p.alocated = p.quantidade_expedicao ? true : false
          p.qte_alocated = p.quantidade_expedicao ? p.quantidade_expedicao : 0
          p.qte_alocar = p.quantidade_expedicao
          return addValidadeSort(p)
        })
      },

      filterProdutosByEstoque(produtos, selectedEstoque, selectedEstoquesAutomatico, useAlgoritmo) {
        if (produtos.length === 0) {
          return []
        }

        if (!selectedEstoque) {
          return []
        }

        if (!useAlgoritmo) {
          if (selectedEstoque.id) {
            return produtos.filter(produto => produto.estoque_id === selectedEstoque.id)
          } else {
            return produtos
          }
        } else if (useAlgoritmo) {
          if (selectedEstoque.id) {
            return produtos.filter(produto => produto.estoque_id === selectedEstoque.id)
          } else {
            return produtos.filter(produto =>
              selectedEstoquesAutomatico.map(estoque => estoque.id).includes(produto.estoque_id),
            )
          }
        }

        return []
      },

      getProdutosPalletsEstoque(selectedTp, expedicaoId, productId) {
        EstoqueHttp.getPalletsFromEstoqueParaExpedir(selectedTp, expedicaoId, productId)
          .then(res =>
            setState(prevState => ({
              ...prevState,
              produtosPalletsEstoque: this.mapProdutosFromEstoque(res),
              originalprodutosPalletsEstoque: this.mapProdutosFromEstoque(res),
              loadingMessage: LOAD_MESSAGE.PRODUCTS_FROM_STOCK,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      //Events
      async onInit(selectedTp, expedicaoId) {
        if (!selectedTp) {
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
        } else {
          await EstoqueHttp.getProdutosFromExpedicaoId(selectedTp, expedicaoId)
            .then(res => {
              setState(prevState => ({
                ...prevState,
                produtosParaExpedir: res,
                originalProdutosExpedir: res,
                loadingMessage: LOAD_MESSAGE.GET_ESTOQUES,
              }))
            })
            .catch(err =>
              setState(prevState => ({ ...prevState, errorMessage: errorHandler(err) })),
            )
        }
      },

      onChange(name, value) {
        setState(prevState => {
          if (name === 'selectedProduto') {
            if (!value && prevState[name].qte_faltante !== prevState[name].quantidade)
              return { ...prevState }
            else if (!value) {
              prevState[name] = value
              prevState.activeMainTab = 0
            } else {
              prevState[name] = value
              prevState.loadingMessage = LOAD_MESSAGE.PALLETS_FROM_STOCK
              prevState.activeMainTab = 1
            }
          } else {
            prevState[name] = value
            if (name === 'selectedEstoquesAutomatico') {
              prevState.estoquesFilteredByAutomatico = prevState.estoques.filter(
                e => value.map(e => e.id).includes(e.id) || e.id === 0,
              )
              if (!value.length) prevState.estoquesFilteredByAutomatico = null
              if (!prevState.selectedEstoque && value.length)
                prevState.selectedEstoque = { id: 0, name: 'Todos' }
              if (
                prevState.selectedEstoque &&
                !value.map(e => e.id).includes(prevState.selectedEstoque.id)
              )
                prevState.selectedEstoque = { id: 0, name: 'Todos' }
            } else if (name === 'useAlgoritmo') {
              if (value) prevState.selectedEstoque = null
              else {
                prevState.selectedEstoque = { id: 0, name: 'Todos' }
                prevState.selectedEstoquesAutomatico = null
                prevState.estoquesFilteredByAutomatico = null
              }
            }
          }
          return { ...prevState }
        })
      },

      onTabChange(value) {
        if (value === 0)
          setState(prevState => ({
            ...prevState,
            activeIndex: value,
            loadingMessage: LOAD_MESSAGE.LOAD_CUSTOMERS,
          }))
        else setState(prevState => ({ ...prevState, activeIndex: value }))
      },

      onChangeProduto(produtoId, value, name) {
        setState(prevState => {
          const index = prevState.produtosEstoque.findIndex(p => p.id === produtoId)
          if (index !== -1) {
            prevState.produtosEstoque[index][name] = value
          }
          return { ...prevState }
        })
      },

      onChangePallet(id, value, name) {
        setState(prevState => {
          const index = prevState.produtosPalletsEstoque.findIndex(p => p.id === id)
          if (index !== -1) {
            prevState.produtosPalletsEstoque[index][name] = value
          }
          return { ...prevState }
        })
      },

      onSearchProdutosExpedicaoChange(value) {
        setState(prevState => {
          prevState.searchProdutosExpedicao = value

          if (!prevState.originalProdutosExpedir.length) return { ...prevState }

          if (!value.length) prevState.produtosParaExpedir = prevState.originalProdutosExpedir
          else {
            prevState.produtosParaExpedir = prevState.originalProdutosExpedir.filter(p =>
              p.name.toString().toLowerCase().includes(value.toLowerCase()),
            )
          }

          return { ...prevState }
        })
      },

      onSearchprodutosPalletsEstoqueChange(value) {
        setState(prevState => {
          prevState.searchprodutosPalletsEstoque = value

          if (!prevState.originalprodutosPalletsEstoque.length) return { ...prevState }

          if (!value.length)
            prevState.produtosPalletsEstoque = prevState.originalprodutosPalletsEstoque
          else {
            prevState.produtosPalletsEstoque = prevState.originalprodutosPalletsEstoque.filter(p =>
              p.pallet_area_id.toString().toLowerCase().includes(value.toLowerCase()),
            )
          }

          return { ...prevState }
        })
      },

      onClickPalletEstoque(pallet) {
        setState(prevState => {
          const index = prevState.selectedProdutosPallets.findIndex(
            p => p.pallet_area_id === pallet.pallet_area_id,
          )
          if (index === -1) {
            prevState.selectedProdutosPallets.push(pallet)
          } else {
            prevState.selectedProdutosPallets = prevState.selectedProdutosPallets.filter(
              p => p.pallet_area_id !== pallet.pallet_area_id,
            )
          }
          return { ...prevState }
        })
      },

      isProdutoPalletAlocated(produtosPalletsEstoque, produtoPallet) {
        const index = produtosPalletsEstoque.findIndex(p => p.id === produtoPallet.id && p.alocated)
        return index !== -1
      },

      isProdutoEstoqueAlocated(produtosEstoque, produto) {
        const index = produtosEstoque.findIndex(p => p.id === produto.id && p.alocated)
        return index !== -1
      },

      isRowDisable(selectedProduto, row) {
        if (!selectedProduto) return false
        if (selectedProduto.qte_faltante === selectedProduto.quantidade) return false
        if (row.id === selectedProduto.id) return false
        return true
      },

      onClickProdutoExpedicao(produto) {
        setState(prevState => ({
          ...prevState,
          selectedProduto: produto,
          produtosEstoque: [],
          produtosPalletsEstoque: [],
          loadingMessage: LOAD_MESSAGE.PALLETS_FROM_STOCK,
        }))
      },

      onClickPallets(pallet) {
        setState(prevState => {
          const index = prevState.pallets.findIndex(p => p.id === pallet.id)
          prevState.pallets[index].selected = !prevState.pallets[index].selected

          return { ...prevState }
        })
      },

      onClickAlocarPallet(selectedProdutosPallets, selectedProduto) {
        setState(prevState => {
          if (
            !this.sumQuantiaSelecionada(selectedProdutosPallets, prevState.selectedProdutosEstoque)
          )
            return {
              ...prevState,
              errorMessage: 'Selecione itens/item que não possua Qte Expedição igual a 0',
            }
          if (
            selectedProduto.qte_faltante <
            this.sumQuantiaSelecionada(selectedProdutosPallets, prevState.selectedProdutosEstoque)
          )
            return {
              ...prevState,
              errorMessage:
                'Você está tentando alocar uma quantidade maior que o numero de itens faltantes.',
            }
          if (
            selectedProdutosPallets.some(
              sp => sp.qte_alocar > sp.quantidade - sp.quantidade_expedicoes,
            )
          )
            return {
              ...prevState,
              errorMessage:
                'Existem produto com uma quantidade maior do que a disponivel para expedição',
            }
          if (selectedProdutosPallets.some(sp => Number(sp.qte_alocar) <= 0))
            return { ...prevState, errorMessage: 'Vocẽ não pode alocar 0 ou menos em expedições.' }

          for (const selectedProdutoPallet of selectedProdutosPallets) {
            if (!prevState.produtosPalletsEstoque.length) return { ...prevState }
            prevState.produtosPalletsEstoque.forEach(p => {
              if (p.id === selectedProdutoPallet.id) {
                p.qte_alocated = Number(p.qte_alocar)
                p.alocated = true
                p.produto = selectedProduto
              }
            })

            prevState.produtosParaExpedir.forEach(p => {
              if (p.id === selectedProduto.id) {
                p.qte_faltante -= selectedProdutoPallet.qte_alocar
              }

              return p
            })

            prevState.selectedProdutosPallets = []
          }

          return { ...prevState }
        })
      },

      onClickAlocarProduto(selectedProdutosEstoque, selectedProduto) {
        setState(prevState => {
          if (
            !this.sumQuantiaSelecionada(selectedProdutosEstoque, prevState.selectedProdutosPallets)
          )
            return {
              ...prevState,
              errorMessage: 'Selecione itens/item que não possua Qte Expedição igual a 0',
            }
          if (
            selectedProduto.qte_faltante <
            this.sumQuantiaSelecionada(selectedProdutosEstoque, prevState.selectedProdutosPallets)
          )
            return {
              ...prevState,
              errorMessage:
                'Você está tentando alocar uma quantidade maior que o numero de itens faltantes.',
            }
          if (selectedProdutosEstoque.some(sp => sp.qte_alocar > sp.quantidade))
            return {
              ...prevState,
              errorMessage:
                'Existem produto com uma quantidade maior do que a disponivel para expedição',
            }
          if (
            selectedProdutosEstoque.some(
              sp => sp.qte_alocar > sp.quantidade - sp.quantidade_expedicoes,
            )
          )
            return {
              ...prevState,
              errorMessage: 'Esse produto não possui quantidade disponivel para alocação',
            }
          if (selectedProdutosEstoque.some(sp => Number(sp.qte_alocar) <= 0))
            return { ...prevState, errorMessage: 'Vocẽ não pode alocar 0 ou menos em expedições.' }

          for (const selectedProdutoEstoque of selectedProdutosEstoque) {
            if (!prevState.produtosEstoque.length) return { ...prevState }

            prevState.produtosEstoque.forEach(p => {
              if (p.id === selectedProdutoEstoque.id) {
                p.qte_alocated = Number(p.qte_alocar)
                p.alocated = true
                p.produto = selectedProduto
              }
            })

            prevState.produtosParaExpedir.forEach(p => {
              if (p.id === selectedProduto.id) {
                p.qte_faltante -= selectedProdutoEstoque.qte_alocar
              }
            })

            prevState.selectedProdutosEstoque = []
          }

          return { ...prevState }
        })
      },

      onClickDesalocarPallet(selectedProdutosPallets) {
        setState(prevState => {
          if (!selectedProdutosPallets.length) return { ...prevState }

          for (const selectedProduto of selectedProdutosPallets) {
            if (!prevState.produtosPalletsEstoque.length) return { ...prevState }
            if (!this.isProdutoPalletAlocated(prevState.produtosPalletsEstoque, selectedProduto))
              continue

            prevState.produtosParaExpedir.forEach(p => {
              if (p.product_id === selectedProduto.product_id) {
                p.qte_faltante += selectedProduto.qte_alocated
              }
            })

            prevState.produtosPalletsEstoque.forEach(p => {
              if (p.id === selectedProduto.id) {
                p.alocated = false
                p.produto = null
                p.qte_alocar = 0
                p.qte_alocated = 0
              }
            })

            prevState.selectedProdutosPallets = []
          }

          return { ...prevState }
        })
      },

      onClickDesalocarProduto(selectedProdutos) {
        setState(prevState => {
          if (!selectedProdutos.length) return { ...prevState }
          for (const selectedProduto of selectedProdutos) {
            if (!prevState.produtosEstoque.length) return { ...prevState }
            if (!this.isProdutoEstoqueAlocated(prevState.produtosEstoque, selectedProduto)) continue

            prevState.produtosParaExpedir.forEach(p => {
              if (p.product_id === selectedProduto.product_id) {
                p.qte_faltante += selectedProduto.qte_alocated
              }
            })

            prevState.produtosEstoque.forEach(p => {
              if (p.id === selectedProduto.id) {
                p.alocated = false
                p.produto = null
                p.qte_alocar = 0
                p.qte_alocated = 0
              }
            })

            prevState.selectedProdutosEstoque = []
          }

          return { ...prevState }
        })
      },

      async onClickExpedir(
        produtosPalletsEstoque,
        produtosEstoque,
        selectedProduto,
        expedicaoId,
        selectedTp,
      ) {
        const produtosAlocadosPallet = produtosPalletsEstoque.filter(p => p.alocated)
        const produtosAlocadosAvulso = produtosEstoque.filter(p => p.alocated)

        if (!selectedProduto)
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione pelo menos 1 produto' }))
        else {
          await EstoqueHttp.postExpedirProduto(
            selectedTp,
            selectedProduto.product_id,
            expedicaoId,
            { produtosPallet: produtosAlocadosPallet, produtosAvulso: produtosAlocadosAvulso },
          )
            .then(res =>
              setState(prevState => ({
                ...prevState,
                loadingMessage: LOAD_MESSAGE.PRODUCTS,
              })),
            )
            .catch(err =>
              setState(prevState => ({
                ...prevState,
                errorMessage: errorHandler(err),
                loadingMessage: LOAD_MESSAGE.NONE,
              })),
            )
        }
      },

      efetuarAssocAutomatico(selectedAlgoritmo, selectedEstoques) {
        if (!selectedAlgoritmo)
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione um método e tente novamente.',
          }))
        else if (!selectedEstoques.length)
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione pelo menos um estoque e tente novamente.',
          }))
        else {
          if (selectedAlgoritmo.value === 'FIFO') {
            setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.ASSOC_FIFO }))
          } else {
            setState(prevState => ({ ...prevState, errorMessage: 'Método não homologado' }))
          }
        }
      },

      async assocAutomaticoFifo(expedicaoId, tpId, selectedEstoques) {
        await EstoqueHttp.associarPosicoesFIFO(
          expedicaoId,
          tpId,
          selectedEstoques.map(s => s.id),
        )
          .then(res =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.PRODUCTS,
              produtosParaExpedir: [],
              originalProdutosExpedir: [],
              successMessage: 'Associação via FIFO efetuado com sucesso',
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: err,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      canAlocar(selectedItems) {
        return selectedItems.every(p => !p.alocated)
      },

      canDesalocar(selectedItems) {
        return selectedItems.every(p => p.alocated)
      },

      sumQuantiaSelecionada(selectedProdutosPallets, selectedProdutosEstoque) {
        return (
          selectedProdutosPallets
            .map(sp => Number(sp.qte_alocar))
            .reduce((prev, curr) => prev + curr, 0) +
          selectedProdutosEstoque
            .map(sp => Number(sp.qte_alocar))
            .reduce((prev, curr) => prev + curr, 0)
        )
      },
    }
  }, [])

  return { state, localDispatch }
}
